import * as Yup from 'yup';

export const cancelAppointmentActionValidationSchema = Yup.object({
  notes: Yup.string().trim().required('Il campo è obbligatorio'),
});
